import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";

export const VehicleCard = ({ vehicle, index = 0 }) => {
  return (
    <Link
      to={`/vehicle/${vehicle.id}`}
      className="vehicle-card block group tracing-beam"
      style={{ animationDelay: `${index * 100}ms` }}
      data-testid={`vehicle-card-${vehicle.id}`}
    >
      {/* Image */}
      <div className="relative overflow-hidden">
        <img
          src={vehicle.image_url}
          alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
          className="vehicle-image"
          loading="lazy"
        />
        {/* Availability Badge */}
        <div className="absolute top-4 left-4">
          {vehicle.available ? (
            <span className="badge-available">
              <Check className="w-3 h-3 mr-1" />
              Available
            </span>
          ) : (
            <span className="badge-unavailable">Not Available</span>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Year & Color */}
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">
            {vehicle.year}
          </span>
          <span className="w-1 h-1 bg-slate-300 rounded-full"></span>
          <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">
            {vehicle.color}
          </span>
        </div>

        {/* Make & Model */}
        <h3 className="font-heading font-bold text-xl text-slate-900 mb-3 group-hover:text-primary transition-colors duration-200">
          {vehicle.make} {vehicle.model}
        </h3>

        {/* Description */}
        <p className="text-slate-600 text-sm mb-4 line-clamp-2">
          {vehicle.description}
        </p>

        {/* Features */}
        {vehicle.features && vehicle.features.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {vehicle.features.slice(0, 3).map((feature, i) => (
              <span
                key={i}
                className="text-xs px-2 py-1 bg-slate-100 text-slate-600"
              >
                {feature}
              </span>
            ))}
          </div>
        )}

        {/* Price & CTA */}
        <div className="flex items-center justify-between pt-4 border-t border-slate-100">
          <div>
            <span className="price-tag">$200</span>
            <span className="text-slate-500 text-sm">/week</span>
          </div>
          <span className="flex items-center text-primary text-sm font-medium group-hover:gap-2 transition-all duration-200">
            View Details
            <ArrowRight className="w-4 h-4 ml-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
          </span>
        </div>
      </div>
    </Link>
  );
};
